import { scheduleEventPriority } from "../../../../../../../../../../_shared/_logic/outreach-presentation"

export const deriveRelevantScheduleEvents = (scheduleEvents: ScheduleEvent[]) => {
  const grouped: Record<string, ScheduleEvent[]> = {}
  scheduleEvents.forEach((event) => {
    if (!event.work_order_id) return

    if (["CANCELED", "NOSHOW"].includes(event.status)) return

    grouped[event.work_order_id] = [...(grouped[event.work_order_id] ?? []), event]
  })

  const bestPerOrder: Record<string, ScheduleEvent> = {}
  Object.entries(grouped).forEach(([orderId, events]) => {
    const sorted = [...events].sort((a, b) => {
      const priorityDiff =
        (scheduleEventPriority[b.status] ?? 0) - (scheduleEventPriority[a.status] ?? 0)

      if (priorityDiff !== 0) return priorityDiff

      const aStart = new Date(a.start_at).getTime()
      const bStart = new Date(b.start_at).getTime()

      if (!Number.isFinite(aStart) && Number.isFinite(bStart)) return 1

      if (!Number.isFinite(bStart) && Number.isFinite(aStart)) return -1

      return bStart - aStart
    })

    if (sorted[0]) {
      bestPerOrder[orderId] = sorted[0]
    }
  })

  return bestPerOrder
}
